import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Drawer, Table } from 'antd';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3FormInput from '@Uilib/h3FormInput';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import Helpers from '@Apis/helpers';
import { v4 as uuidv4 } from 'uuid';

const TallyAddressTypes = ({
  tallyConnections,
  setStep,
  connectTenantToTallyLocationLoading,
  connectTenantToTallyLocation,
  getTallyConnectionsLoading,
  stepNumber,
}) => {

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [tallyAddressTypes, setTallyAddressTypes] = useState([]);
  const [showCreateDrawer, setShowCreateDrawer] = useState(false);
  const [addressType, setAddressType] = useState({
    address_type: '',
    is_default: false,
    key: uuidv4(),
  });

  const integrationTallyIdURL = Number(Helpers.getValueFromUrl('it_id'));
  const tallyConnectionsFilteredData = tallyConnections?.filter((connection) => connection?.it_id === integrationTallyIdURL);

  useEffect(() => {

    if (!!tallyConnections) {

      const types = tallyConnectionsFilteredData?.[0]?.tally_address_types?.map((item) => (
        {
          ...item,
          key: uuidv4(),
        }
      ));
      setTallyAddressTypes(types);
    }
  }, [tallyConnections]);

  const handleSubmit = () => {

    const payload = {
      ...tallyConnectionsFilteredData?.[0],
      tally_address_types: tallyAddressTypes?.map((item) => ({
        address_type: item?.address_type,
        is_default: item?.is_default,
      })),
    };

    connectTenantToTallyLocation(payload, () => {
      setStep(stepNumber + 1);
    });
  };

  const columns = [
    {
      title: 'Address Type',
      width: '312px',
      render: (record) => (
        <div>
          {record?.address_type}
        </div>
      ),
    },
  ];

  const getDataSource = (data) => (data ? JSON.parse(JSON.stringify(data)) : []);

  return (
    <Fragment>
      {getTallyConnectionsLoading ? (
        <div className="tally-integration__loader__wrapper">
          {[...Array(5).keys()].map((item) => (
            <div key={item} className="tally-integration__loader-row">
              <div className="loadingBlock tally-integration__loader__line1" />
              <div className="loadingBlock tally-integration__loader__line2" />
              <div className="loadingBlock tally-integration__loader__line3" />
            </div>
          ))}
          <div className="loadingBlock tally-integration__loader__line-btn1" />
          <div className="loadingBlock tally-integration__loader__line-btn2" />
        </div>
      ) : (
        <div>
          <div className="integration-step__wrapper">
            <div className="ant-row">
              <div className="ant-col-md-18">
                <Table
                  title={() => (
                    <div className='address-type__table-title'>
                      <div className='address-type__table-title__left'>
                        Tally Address Types
                      </div>
                      <div className='address-type__table-title__right'>
                        {/* <Button
                          type="primary"
                          onClick={() => setShowCreateDrawer(true)}
                          disabled={connectTenantToTallyLocationLoading}
                          loading={connectTenantToTallyLocationLoading}
                        >
                          Add Tally Address Type
                        </Button> */}
                        <H3Button
                          buttonType={defaultButtonTypes.BLUE_ROUNDED}
                          text="Add Tally Address Type"
                          onClick={() => setShowCreateDrawer(true)}
                          isLoading={connectTenantToTallyLocationLoading}
                          disabled={connectTenantToTallyLocationLoading}
                          style={{
                            width: '200px',
                            borderRadius: '5px',
                            padding: '7px 0px',
                            marginLeft: '0',
                          }}
                        />
                      </div>
                    </div>
                  )}
                  columns={columns}
                  loading={getTallyConnectionsLoading || connectTenantToTallyLocationLoading}
                  dataSource={getDataSource(tallyAddressTypes) || []}
                  size="small"
                  pagination={false}
                />
              </div>
            </div>
          </div>
          <div className="integration-step__footer" style={{ display: 'flex', paddingTop: '10px', paddingLeft: '15px' }}>
            <Button
              type="primary"
              ghost
              onClick={() => setStep(stepNumber - 1)}
              disabled={connectTenantToTallyLocationLoading}
            >
              Back
            </Button>
            &nbsp;&nbsp;
            <Button
              type="primary"
              onClick={() => handleSubmit()}
              disabled={connectTenantToTallyLocationLoading}
              loading={connectTenantToTallyLocationLoading}
            >
              Save and Continue
            </Button>
          </div>
        </div>
      )}
      <Drawer
        open={showCreateDrawer}
        onClose={() => setShowCreateDrawer(false)}
        width="400px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: "680px" }}>
            <H3Text
              text="Add Tally Address Type"
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setShowCreateDrawer(false)}
            />
          </div>
        </div>
        <div className='custom-drawer__content-wrapper'>
          <div className="ant-col-md-6">
            <div className="custom-drawer__input-row">
              <div className='custom-drawer__input-label'>
                Address Type Name
                <span style={{ color: 'red', marginLeft: '2px', }}>*</span>
              </div>
              <H3FormInput
                name="a valid address type name"
                type="text"
                containerClassName=""
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput input"
                placeholder=""
                onChange={(event) => setAddressType({ ...addressType, address_type: event?.target?.value })}
                value={addressType?.address_type}
                showError={formSubmitted && !addressType?.address_type?.trim()?.length}
                disabled={connectTenantToTallyLocationLoading}
                required
              />
            </div>
          </div>
        </div>
        <div className="custom-drawer__footer">
          <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text="Add Address Type"
              onClick={() => {

                setFormSubmitted(true);
                if (!!addressType?.address_type?.trim()?.length) {

                  setFormSubmitted(false);
                  setShowCreateDrawer(false);
                  setTallyAddressTypes([...tallyAddressTypes, addressType]);
                  setAddressType({
                    ...addressType,
                    address_type: '',
                  });
                }
              }}
              isLoading={connectTenantToTallyLocationLoading}
              disabled={connectTenantToTallyLocationLoading}
              style={{
                width: '200px',
                borderRadius: '5px',
                padding: '7px 0px',
                marginLeft: '0',
              }}
            />
          </div>
        </div>
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({
  TallyIntegrationReducers,
}) => ({
  tallyConnections: TallyIntegrationReducers.tallyConnections,
  connectTenantToTallyLocationLoading: TallyIntegrationReducers.connectTenantToTallyLocationLoading,
});

const mapDispatchToProps = (dispatch) => ({
  connectTenantToTallyLocation: (payload, callback) => dispatch(TallyIntegrationActions.connectTenantToTallyLocation(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TallyAddressTypes));